import { PROJECT_ID } from '../config.js';

// TODO: Refactor this function so it not use callbacks to pass data
const getAvailableLanguages = (cdn, application) => async callback => {
  try {
    const languagesResponse = await fetch(`${cdn}/translations/${PROJECT_ID[application]}/languages.json`);
    const languages = await languagesResponse.json();
    const formattedLanguages = Object.keys(languages).map(key => ({
      language: languages[key],
      locale: key
    }));
    callback(formattedLanguages);
  } catch {
    callback([]);
  }
};

export { getAvailableLanguages };
//# sourceMappingURL=languageUtils.js.map
